import { Link } from 'react-router-dom';
import { useAuth } from 'shared/hooks/useAuth';
import { Card } from 'shared/components/ui/Card';
import { Badge } from 'shared/components/ui/Badge';
import { ROUTES } from 'shared/constants/routes';
import { useProfile } from 'modules/jogador/profile/useProfile';
import { Skeleton } from 'shared/components/ui/Skeleton';

export function ProfilePage() {
  const { user } = useAuth();
  const { sportLevels, isLoading } = useProfile();

  if (!user) {
    return (
      <section className="mx-auto max-w-md px-4 py-12 text-center">
        <h1 className="font-heading text-2xl font-bold text-ink">Você está navegando como visitante</h1>
        <p className="mt-2 text-sm text-ink-secondary">
          Escolha uma persona na barra "modo apresentação" no topo para ver um perfil, ou entre
          com uma conta.
        </p>
        <Link to={ROUTES.LOGIN} className="mt-4 inline-block font-medium text-primary hover:underline">
          Ir para o login
        </Link>
      </section>
    );
  }

  return (
    <section className="mx-auto max-w-md px-4 py-12">
      <h1 className="font-heading text-2xl font-bold text-ink">Meu Perfil</h1>

      <Card className="mt-6">
        <p className="text-sm text-ink-secondary">Nome</p>
        <p className="font-medium text-ink">{user.name}</p>

        <p className="mt-4 text-sm text-ink-secondary">E-mail</p>
        <p className="font-medium text-ink">{user.email}</p>

        <p className="mt-4 text-sm text-ink-secondary">Perfil</p>
        <Badge className="mt-1 capitalize">{user.role}</Badge>
      </Card>

      {user.role === 'jogador' && (
        <Card className="mt-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-ink-secondary">
            Perfil esportivo
          </p>
          <div className="mt-3 flex flex-col gap-2">
            {isLoading
              ? [96, 72, 84].map((width) => (
                  <div key={width} className="flex items-center justify-between" aria-hidden="true">
                    <Skeleton className="h-3.5" style={{ width }} />
                    <Skeleton className="h-6 w-24 rounded-full" />
                  </div>
                ))
              : sportLevels.map((sportLevel) => (
                  <div key={sportLevel.sport} className="flex items-center justify-between">
                    <span className="text-sm text-ink">{sportLevel.sport}</span>
                    <Badge tone="accent">{sportLevel.level}</Badge>
                  </div>
                ))}
          </div>
        </Card>
      )}

      <p className="mt-4 text-center text-sm text-ink-secondary">
        Esta é uma persona de demonstração. Use a barra "modo apresentação" no topo para trocar,
        ou veja como seriam as telas reais de{' '}
        <Link to={ROUTES.LOGIN} className="font-medium text-primary hover:underline">
          login
        </Link>{' '}
        e{' '}
        <Link to={ROUTES.SIGNUP} className="font-medium text-primary hover:underline">
          cadastro
        </Link>
        .
      </p>
    </section>
  );
}
